<template>
  <v-container>
    <v-form v-model="isValid" class="form" ref="form">
      <v-text-field
        label="Imei"
        mask="################"
        v-model="form.imei"
        :rules="[validate.required, validate.numeric]"
        :error-messages="validateImeiString"
        @change="checkImeiFromServer()"
      ></v-text-field>
      <v-text-field label="Tên chi nhánh" v-model="form.plate" :rules="[validate.required]"></v-text-field>
      <v-text-field
        label="Số điện thoại của thiết bị"
        mask="################"
        v-model="form.simPhone"
        :rules="[validate.required, validate.numeric, validate.min]"
      ></v-text-field>
      <v-text-field label="Ngân hàng" v-model="form.vehicleBrand"></v-text-field>
      <span>Biểu tượng xe</span>
      <v-radio-group v-model="form.vehicleType" :rules="[validate.required]">
        <v-radio label="Xe máy" :value="1"></v-radio>
        <v-radio label="Xe ôtô" :value="2"></v-radio>
        <v-radio label="Biểu tượng mũi tên" :value="3"></v-radio>
      </v-radio-group>
      <v-btn block round color="success" @click="submit()" :loading="isLoading">Hoàn thành</v-btn>
    </v-form>
  </v-container>
</template>

<script>
import validate from '@/utils/validate';
import { mapActions, mapMutations } from 'vuex';

export default {
  data: () => ({
    isValid: false,
    isLoading: false,
    validate: validate,
    validateImeiString: '',
    form: {
      imei: '',
      plate: '',
      simPhone: '',
      vehicleBrand: '',
      vehicleType: 3
    }
  }),
  methods: {
    ...mapActions(['createVehicle', 'checkImei']),
    ...mapMutations(['CREATE_VEHICLE']),
    checkImeiFromServer () {
      if (this.form.imei && validate.numeric(this.form.imei)) {
        this.checkImei(this.form.imei)
          .then(result => {
            this.validateImeiString = '';
          })
          .catch(result => {
            this.validateImeiString =
              result.code === 'ERR_IMEI_NOT_EXIST'
                ? 'Số Imei không tồn tại trong hệ thống'
                : result.code === 'ERR_IMEI_USED'
                  ? 'Số Imei đã được sử dụng'
                  : '';
          });
      }
    },
    submit () {
      if (this.isValid) {
        this.isLoading = true;
        this.createVehicle(this.form)
          .then(res => {
            window.getApp.showMessage('Tạo xe thành công');
            this.isLoading = false;
            this.CREATE_VEHICLE(res);
            this.$emit('show', false);
            this.form = {
              vehicleType: 1
            };
          })
          .catch(_ => {
            this.isLoading = false;
            window.getApp.showMessage(
              'Tạo xe thất bại, vui lòng thử lại',
              'error'
            );
          });
      } else {
        this.$refs.form.validate();
      }
    }
  }
};
</script>
<style scoped lang="css">
#login {
  height: 50%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  content: "";
  z-index: 0;
}
.login-btn {
  color: white !important;
}
.v-card__text {
  padding-left: 0px;
  padding-right: 0px;
  padding-bottom: 0px;
}
.form {
  min-height: 200px;
}
p {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/vehicle/components/add.vue